export const handleDownload = async (e, fileUrl, fileName) => {
    e.preventDefault();
        
    try {
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error("Download failed");

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = fileName || 'downloaded-file'; 
            
        document.body.appendChild(a);
        a.click(); 
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        console.error("Error when downloading file:", error);
        alert("The file could not be loaded. Please try again.");
    }
};